<template>
  <QjListTemplateWhatsApp/>
</template>
<script>
import QjListTemplateWhatsApp from "@/components/QjListTemplateWhatsApp";

export default {
  name: "QjListTemplateWhatsAppView",
};
</script>
